import { PROGRAM_PROPOSAL_ROUTE_SLUGS } from './programGridMediaKitProposals';

/**
 * Propuestas con landing dedicada en ruta raíz `/${slug}` (sin prefijo /show).
 */
const STATIC_FULL_LANDING_SLUGS_BASE = [
  'gpm-eventos',
  'ladosispositiva',
  'puntodefe',
  'somospadres',
  'vivirenequilibrio',
  'tnosports',
  'siempremasmusica',
  'vidainmobiliaria',
  'marketingenmovimiento',
  'legalmenteenfamilia',
  'enproduccionconmem',
  'hoet-partners',
  'colegio-abogados-caracas',
  '3decopas',
  'lacteosbarinas',
  'bancaribe',
  'papaupa',
  'movistar',
  'artesco',
  'nexus-cultural',
  'atache',
  'danimar',
  'danimar-express',
  'chemical',
  'doctorcondominioradio',
  'tnobusiness',
  'expedientesdeldelito',
  'noticias',
  'actitudplateada',
  'eventopadel',
  'wiki',
  'opticaberlud',
  'corporacion-tisemte',
  'canguro',
  'prudence',
  'altamiravillage',
  'smarttraining',
  'banco-activo-metas-con-proposito',
  'empire-keeway',
  'hyundai-venezuela',
  'dhl-venezuela',
  'lg-venezuela',
  'cafe-san-domingo',
  'alter-gold-programa',
  'alter-gold-publicidad',
  'grupo-express',
  'andreina-roa',
  'harrison-mozo',
  'mercosur-podcast',
  'bolsa-valores-descentralizada',
  'patrocinio-tno-business',
  'franquiciasenvenezuela',
  'comerciocorporativo',
  'despuesdelevento',
  'ensintoniacontusalud',
  '2doescalon',
  'hablemosdetodo',
];

export const STATIC_FULL_LANDING_SLUGS = [
  ...STATIC_FULL_LANDING_SLUGS_BASE,
  ...PROGRAM_PROPOSAL_ROUTE_SLUGS,
];

export const isStaticFullLandingSlug = (slug) => STATIC_FULL_LANDING_SLUGS.includes(slug);

export const staticFullLandingPath = (slug) =>
  isStaticFullLandingSlug(slug) ? `/${slug}` : `/show/${slug}`;

/** Listado de media kits → landing comercial para anunciantes (puede diferir del slug del show). */
const MEDIA_KIT_ADVERTISER_PATH_BY_SLUG = {
  tnobusiness: '/patrocinio-tno-business',
};

export const mediaKitLandingPath = (slug) => {
  const alias = MEDIA_KIT_ADVERTISER_PATH_BY_SLUG[String(slug || '').toLowerCase()];
  if (alias) return alias;
  return staticFullLandingPath(slug);
};
